import SmotriButton from "@components/SmotriButton";
import bannerPhoto from "@images/banner-photo-2.png";
import pattern from "@svg/pattern2.png";

export default function PatternOfferBanner() {
  return (
    <section className="w-full bg-black px-4 py-6 sm:px-8 sm:py-10 xl:px-20 xl:pb-20">
      <div
        className="relative isolate mx-auto box-border flex min-h-[622px] w-full max-w-[1760px] flex-col items-start justify-center overflow-visible rounded-[24px] bg-[#070707] bg-cover bg-center px-6 py-10 sm:px-10 md:px-12 xl:px-20 xl:pb-20 xl:pt-16"
        style={{ backgroundImage: `url(${pattern})` }}
      >
        <div className="pointer-events-none absolute inset-0 -z-10 rounded-[24px]" />

        <div className="relative z-10 flex w-full max-w-[822px] flex-col items-start">
          <h2 className="jost-m max-w-[760px] text-[42px] uppercase leading-[0.98] tracking-[-0.01em] text-white sm:text-[56px] md:text-[76px]">
            Смотрите ТВ <br />и фильмы вместе
          </h2>

          <p className="inter-r mt-6 w-full max-w-[700px] text-xl font-light leading-[150%] tracking-[-0.01em] text-white">
            <span className="font-bold">Smotri</span> — это бесплатный сервис,
            который позволяет смотреть сериалы и фильмы вместе с другими людьми
            на любой крупной стриминговой платформе, в идеальной синхронизации.
          </p>

          <div className="mt-[48px] flex flex-col items-start gap-[14px]">
            <div className="inter-m flex h-6 w-32 items-center whitespace-nowrap text-xl leading-[120%] tracking-[-0.01em] text-white">
              от 500 ₽/мес
            </div>

            <div className="flex h-14 flex-row items-start gap-[12px]">
              <SmotriButton>Получить Smotri Premium</SmotriButton>
              <SmotriButton
                className="flex items-center justify-center rounded-[16px]"
                variant="secondary"
              >
                Узнать больше
              </SmotriButton>
            </div>
          </div>
        </div>

        <img
          className="pointer-events-none absolute bottom-[-52px] right-[-64px] z-0 hidden h-[684px] w-[952px] max-w-none object-contain object-bottom md:block lg:right-[-42px] xl:right-[-18px] 2xl:right-[-6px]"
          src={bannerPhoto}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
}
